import { useMemo } from 'react';
import { WeSpinBadge, BadgeContainer, BadgeNew } from '@comeon/ui';
import styled from 'styled-components';
import StreamElement from './game-room/stream-element.js';
import generateSrcSet from '../../../utils/generateSrcSet.js';
import Icon, { ICON_WE_SPIN } from '~/components/icon/index.js';
import { useSelector } from 'react-redux';
import { selectConfiguration } from '~/components/we-spin/old-flow/ducks/we-spin-selectors';

const SIZES = '480px';

const Overlay = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 0;
	left: 0;
`;
const OverlayContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const OverlayCaption = styled.div`
	font-weight: 500;
	font-size: 19px;
	line-height: 24px;
	align-items: center;
	color: #ffffff;
	margin-top: 0;
`;

const WeSpinSessionCardImage = ({ isOnline, onClickLink, boostTypes, session, streamView }) => {
	const configuration = useSelector(selectConfiguration);
	const { weSpinLobbyStreamPreviewsDisabled } = configuration;
	const src = useMemo(
		() => streamView?.streamBgUrl || streamView?.streamerImgUrl,
		[streamView?.streamerImgUrl, streamView?.streamBgUrl]
	);
	const srcSet = useMemo(() => (src ? generateSrcSet(src, true) : null), [src]);
	return (
		<div
			role="presentation"
			onClick={onClickLink}
			className="item__image large-item-img-wrapper u-relative u-b-radius-top u-cursor-hand gamecard-tags"
		>
			<BadgeContainer className="badge-container--lobby">
				{!!streamView?.isPrivateStreamer && <BadgeNew>PRIVATE</BadgeNew>}
				{boostTypes.size > 0 &&
					[...boostTypes].map(boostText => <WeSpinBadge key={boostText}>{boostText}</WeSpinBadge>)}
			</BadgeContainer>
			{isOnline && !streamView?.privateStreamer && !weSpinLobbyStreamPreviewsDisabled ? (
				<StreamElement size="lobby" interactive={false} type="STREAM" streamLinkUrl={session.streamUrl} />
			) : (
				<img
					alt="Add profile info"
					sizes={SIZES}
					className="item__img u-b-radius-top u-object-fit-cover"
					src={src}
					srcSet={srcSet}
				/>
			)}
			{!!streamView?.isPrivateStreamer && (
				<Overlay>
					<OverlayContent>
						<Icon type={ICON_WE_SPIN} width="95" height="75" />
						<OverlayCaption>Friends</OverlayCaption>
					</OverlayContent>
				</Overlay>
			)}
		</div>
	);
};

export default WeSpinSessionCardImage;
